import React from "react";
import PremiumUserPastTable from "./PremiumUsersPastTable";

export default function PremiumUserPast() {
  return (
    <div className="default-tab">
      <PremiumUserPastTable />
    </div>
  );
}
